import { render } from "./DashboardSidebar.vue?vue&type=template&id=5f428a3e&scoped=true"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js"

import "./DashboardSidebar.vue?vue&type=style&index=0&id=5f428a3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f428a3e"]])

export default __exports__